import { Empty } from 'antd';
import React from 'react';
import LoaderComponent from '../../../components/LoaderComponent';
import RackMasterInventoryCard from './RackMasterInventoryCard';

const RackMasterInventoryList = ({
  inventoryList,
  isInventoryLoading,
  isEmptyRackMasterList,
  infiniteScrollRef,
  setVisible,
  setToyImages,
}) => (
  <div>
    {!isEmptyRackMasterList &&
      inventoryList?.map((order) => (
        <RackMasterInventoryCard
          infiniteScrollRef={infiniteScrollRef}
          key={order?.id}
          record={order}
          setVisible={setVisible}
          setToyImages={setToyImages}
        />
      ))}
    {isInventoryLoading && <LoaderComponent size="small" setHeight={10} />}
    {isEmptyRackMasterList && <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />}
  </div>
);

export default RackMasterInventoryList;
